import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    proclamation: {
        marginBottom: '1rem',
    },
    content: {
        maxWidth: '800px',
    },
    link: {
        display: 'block',
        marginTop: '0.5rem',
        width: '100px',
    },
});
